import { Component } from 'react';
import styles from 'styles/loading';

export default class Loading extends Component {
	render() {
		return (
			<div className={styles.loading}>
				<div className={styles.spinner} />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./scripts/components/Loading.es6